import vtkInteractorStyleManipulator from '@kitware/vtk.js/Interaction/Style/InteractorStyleManipulator';
import InteractionPresets from '@kitware/vtk.js/Interaction/Style/InteractorStyleManipulator/Presets';
import vtkGestureCameraManipulator from '@kitware/vtk.js/Interaction/Manipulators/GestureCameraManipulator';

function CustomInteractorStyle() {
    const interactorStyle = vtkInteractorStyleManipulator.newInstance();

    // Define custom interaction definitions
    const interactorStyleDefinitions = [
        // Mouse/keyboard interactions
        { type: 'pan', options: { button: 1 } }, // Pan on Left button drag
        { type: 'zoom', options: { button: 1, control: true } }, // Zoom on Ctrl + Left button drag
        { type: 'zoom', options: { dragEnabled: false, scrollEnabled: true } }, // Zoom on scroll
        { type: 'pan', options: { button: 3 } }, // Pan with right mouse button
        { type: 'pan', options: { shift: true, button: 1 } } // Pan with shift + left click
    ];

    // Apply the custom interaction definitions
    InteractionPresets.applyDefinitions(interactorStyleDefinitions, interactorStyle);

    // Add a dedicated gesture manipulator for mobile touch interactions
    const gestureManipulator = vtkGestureCameraManipulator.newInstance();
    gestureManipulator.setPinchEnabled(true);
    gestureManipulator.setPanEnabled(true);
    gestureManipulator.setRotateEnabled(true);
    interactorStyle.addGestureManipulator(gestureManipulator);

    return interactorStyle;
}

export default CustomInteractorStyle;